'use strict';

EditFormCtrl.$inject = ['$q', '$element', 'mx.SolutionBuilderAgent.mxLocalizationModeHelper'];
export default function EditFormCtrl($q, $element, localizationModeHelper) {
	const vm = this;

	vm.save = function () {
		vm.finishDefer.resolve(vm.item);
	};

	vm.cancel = function () {
		vm.finishDefer.reject(mx.noLogCatchMessage('Item editing was canceled'));
	};

	vm.$onInit = function () {
		// Localization mode
		if (vm.__localizationModeEnabled) {
			// vm.localizationData

			localizationModeHelper.enableMode($element);

			const localizableModels = vm.localizationData.fields.map((field) => 'item.' + field);
			localizationModeHelper.applyStylesForControls($element, localizableModels, '.mx-multi-fragment-grid-item-edit-form');

			// Handle events
			$(localizationModeHelper.dialogSelector)[0].addEventListener(
				'click',
				function (event) {
					_handleLocalizationDialogAppearance(
						event,
						_handleLocalizationDialogResult,
						localizableModels,
						vm.item,
						vm.item.__resultCI || $.extend({}, vm.localizationData)
					);
				},
				true
			);
		}
	};

	function _handleLocalizationDialogAppearance(event, dialogSavedCallback, localizableModels, item, sourceCI) {
		const controlElm = localizationModeHelper.preventUsualControlHandler(event, localizableModels);
		if (controlElm) {
			const modelInfo = localizationModeHelper.getModelInfoFromElement(controlElm);
			localizationModeHelper.openLocalizationDialog(controlElm, sourceCI[modelInfo.fieldKey], sourceCI, item[modelInfo.fieldKey]).then(function (params) {
				dialogSavedCallback(params.localizedField, item, modelInfo.fieldKey, params.currentLang);
			}, angular.noop);
		}
		return false;
	}

	function _handleLocalizationDialogResult(localizedField, item, fieldKey, currentLang) {
		item.__resultCI = item.__resultCI || { 'Sys-Owner': item.ID };
		item.__resultCI = localizationModeHelper.applyTranslations(localizedField, fieldKey, item.__resultCI);
		item[fieldKey] = localizationModeHelper.getValueWithFallback(localizedField, currentLang);
	}
}
